import { Component } from 'preact';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

const Input = (props) => (
    <div class={cx("input-container")}>
        <input
            class={cx("input")}
            {...props}
        />
        <button class={cx("button")}>
            Search
        </button>
        <div class={cx("border")} />
    </div>

);

export default Input;


// WEBPACK FOOTER //
// ./components/search/input/index.js